import { uuid as uuidv4 } from './browser';
import { TRACKING_COOKIES } from '../constants';
import { readCookie } from './cookies';
import { getUtmTags, getParsedUrl } from './url';

/**
 * Handles tracking for embed loading, specifically focusing on external referrals.
 * It tracks an 'on-embed-loaded' event when the page is loaded from an external origin,
 * an empty/invalid referrer (direct visit), or when UTM tags are present.
 *
 * @param {Window} window - The browser window object.
 * @param {Document} document - The browser document object.
 * @param {Object} BambuserLiveShopping - The Bambuser Live Shopping global object/constructor.
 */
const embedTrackingHandler = (window, document, BambuserLiveShopping) => {
  const { hasUtmTags, utmObject } = getUtmTags(window.location.href);
  
  const referrerUrl = getParsedUrl(document.referrer);
  
  // We consider it an internal referral ONLY if we can successfully parse the referrer 
  // and its origin matches the current window's origin.
  // Everything else (different origin, empty referrer, invalid URL) is treated as a potential landing.
  const isInternalReferral = referrerUrl.origin === window.location.origin;

  if (isInternalReferral && !hasUtmTags) {
    return;
  }
  
  const userId = readCookie(TRACKING_COOKIES.USER_ID) || `anon-${uuidv4()}`;
  const sessionId = readCookie(TRACKING_COOKIES.SESSION_ID) || uuidv4();

  const pageLoadPayload = {
    location: window.location.href,
    documentReferrer: document.referrer,
    ...utmObject,
  };

  BambuserLiveShopping.prototype._trackMetricEmit({
    userId,
    sessionId,
    source: 'embed',
    eventType: 'on-embed-loaded',
    insertId: uuidv4(),
    payload: pageLoadPayload,
  });
};

export {
  embedTrackingHandler,
};
